<!--首页 俱乐部/考级中心 入口-->
<template>
  <div class="gray-back" style="padding: 0.2rem 0 1rem 0; height: 100%">
    

    <div class="row2 flex-start">
      <div class="row2-li">
        <img
            v-rblink="{ name: 'DakejianList' }"
            src="../../../assets/images/qcxj/icon-dakejian-large2.png"
        />
        <div class="row-tip" style="color: #d12adf">
          {{
            certRow.dakejian && certRow.dakejian.length > 0
                ? "已申报"
                : "未申报"
          }}
        </div>
      </div>
      <div class="row2-li">
        <img
            v-rblink="{ name: 'ClubDetailSihaoApplySuccess' }"
            src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/3b18f8c422e60fb1c43e730c2cfdf893.png"
        />
        <div class="row-tip" style="color: #57e1ab" v-if="certRow.center_list.length>0">
          {{ certRow.sihao }}位
        </div>
      </div>
      <div class="row2-li">
        <img
          v-if="certRow.club.id"
            v-rblink="{ name: 'ClubDetailMine',query:{
              id:certRow.club.id
            } }"
            src="../../../assets/images/qcxj/icon-club-large.png"
        />
        <div class="row-tip" style="color: #50b0ff"  v-if="certRow.club_list.length>0">
          {{ certRow.club_list.length }}家
        </div>
      </div>
    </div>
 
    <div class="row4">
      <img
          v-rblink="{ name: 'NewsList', query: { cate_id: 132 } }"
          src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/605c88c6da07bd6f29f0ed545b04546e.png"
      />
      <img
          v-rblink="{ name: 'NewsList', query: {cate_id:133} }"
          src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/ea32bbda7a94e1987c161b089cbe3d87.png"
      />
      <img
          v-rblink="{ name: 'NewsList', query: { cate_id: 134 } }"
          src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/72806c6294ce4ea3cf60dceb5e368c06.png"
      />
      <img
          v-rblink="{ name: 'NewsList', query: { cate_id: 137 } }"
          src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/a3716d5569ea93799a4caed8deeaa4ee.png"
      />
    </div> 


   <!-- <div class="savebtn">
       <van-button
          v-if="!certRow.club_list.length"
          style="width: 6rem"
          size="large" round >您当前尚未绑定俱乐部</van-button>
      <van-button
          v-else
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 6rem"
          size="large" round @click="toUpdate" >星级俱乐部建设升级申请</van-button>
    </div> -->

        <van-tabs
            v-model="active"
            :class="row.bg_show ? 'active-tab' : ''"
            sticky
            @click="onClick"
        >
          <van-tab
              v-for="(item, index) in activeTab"
              :key="index"
              :type="index"
          >
            <template #title>
              <span class="active-tab-num" v-if="item.num > 0">{{
                  item.num
                }}</span>
              {{ item.name }}
            </template>

          </van-tab>
        </van-tabs>
        <div class="comment-bottom" v-if="sendShow">
          <div class="send-comment">
            <van-field
                v-model="message"
                :placeholder="placeholder"
                show-word-limit
            />
            <div class="send-btn" @click="onCommentSend">发送</div>
          </div>
        </div>
         


    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"  v-show="active==2" >

      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
            <div :key="i" v-for="(item, i) in row.list.list">
              <div
                  v-rblink="{ name: 'NewsDetail', query: { id: item.id } }"
                  v-if="item.style == '-1'"
              >
                <!-- 无图 style==1 -->
                <NewsItem1 :row="item" v-if="item.pics.length == 0"></NewsItem1>
                <!-- 有图 style==2 -->
                <NewsItem2 :row="item" v-if="item.pics.length == 1"></NewsItem2>
                <!-- 视频 style==3 -->
                <NewsItem3 v-if="false"></NewsItem3>
                <!-- 多图 style==4 -->
                <NewsItem4 :row="item" v-if="item.pics.length > 1"></NewsItem4>
              </div>

              <!-- 小图 style==1 -->
              <Activity1
                  v-if="item.style == '1'"
                  :content="item"
                  :index="i"
              ></Activity1>

              <!-- 视频 style==2 -->
              <Activity2
                  v-if="item.style == '2'"
                  :content="item"
                  :index="i"
              ></Activity2>

              <!-- 视频带评论 style==3 -->
              <Activity3
                  v-if="item.style == '3'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event, item, i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event, item, i)"
                  @deleteComment="onDeleteComment($event, i)"
              ></Activity3>

              <!-- 多图带评论 style==4 -->
              <Activity4
                  v-if="item.style == '4'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event, item, i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event, item, i)"
                  @deleteComment="onDeleteComment($event, i)"
              ></Activity4>
              <Activity5
                  v-if="item.style == '5'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event, item, i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event, item, i)"
                  @deleteComment="onDeleteComment($event, i)"
              ></Activity5>
            </div>
      </van-list>

    </van-pull-refresh>



            <div class="notice" v-show="active==0" v-html="notice"></div>


        <van-cell-group  v-show="active==1" >
          <van-cell title="搜索更多俱乐部" is-link v-rblink="{name: 'ClubSearchIndex',query: {}}" />
          <van-cell :value="item.danwei + item.clubleixing" class="flex-start" is-link :key="index" v-for="(item, index) in list"
                    v-rblink="{name: 'ClubDetailUnbind',query: {id: item.id}}">
            <template #icon>
              <img :src="item.pic_url" alt="" style="height: 1.2rem;margin-right: .3rem">
            </template>
          </van-cell>
          <div style="height: 10px"></div>
    


        </van-cell-group>

    <NavFloatAdd :id="this.aparams.id" :back="1"></NavFloatAdd>

    <LoginDialog
        :show="loginShow"
        @loginSuccess="loginSuccess"
        @loginCancel="loginCancel"
    />
  </div>
</template>
<style scoped>
.notice >>> img{ max-width: 100% !important;}
.send-btn {
  width: 1.3rem;
  height: 38px;
  background: linear-gradient(
      90deg,
      rgba(254, 200, 53, 1) 0%,
      rgba(255, 173, 25, 1) 100%
  );
  border-radius: 4px;
  margin-left: 12px;
  line-height: 38px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.send-comment {
  width: 7.1rem;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.comment-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.08rem;
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(236, 236, 236, 1);
}

.release-time-right {
  display: flex;
}

.icon-zan-comment-box {
  width: 175px;
  height: 38.5px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
}

.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}

.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}

.row img {
  width: 100%;
}

.row2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.2rem;
}

.row2-li {
  position: relative;
}

.row-tip {
  position: absolute;
  left: 50%;
  top: 6px;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  -webkit-transform: translate(-50%, -50%);
  font-size: 10px;
}

.row2 img {
  height: 92px;
}

.row4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.2rem 0.2rem 0;
}

.row4 img {
  /*width: 100%;*/
  float: left;
  width: calc(25%);
  margin: 0 10px 10px 0;
}

.row4 img.current {
  box-shadow: 0px 0px 10px 0px rgba(119, 175, 255, 1);
}

.row5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.2rem;
  /*flex-wrap: wrap;*/
}

.row5 img {
  /*width: 100%;*/
  float: left;
  width: calc(33.33%);
  margin: 0 10px 10px 0;
}

.row5 img.current {
  box-shadow: 0px 0px 10px 0px rgba(119, 175, 255, 1);
}

.row2 div:last-child,
.row4 img:last-child,
.row5 img:last-child {
  margin-right: 0;
}

.dialog-head {
  font-size: 0.5rem;
  font-weight: 700;
  text-align: center;
  padding: 0.4rem 0 0.3rem;
}

.dialog-content {
  padding: 0 0.3rem;
  font-size: 14px;
}

.dialog-content >>> .van-button {
  line-height: 1.2;
  font-size: 14px;
}

.dialog-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-step-li {
  margin: 0.2rem 0 0.4rem;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  /* position: fixed; */
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
</style>
<script>
import Vue from "vue";
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import LoginDialog from "@/components/LoginDialog.vue";
import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";

import Activity1 from "@/components/activity/Activity1.vue";
import Activity2 from "@/components/activity/Activity2.vue";
import Activity3 from "@/components/activity/Activity3.vue";
import Activity4 from "@/components/activity/Activity4.vue";
import Activity5 from "@/components/activity/Activity5.vue";
import NavFloatAdd from "@/components/NavFloatAdd.vue";


import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  List,
} from "vant";

Vue.use(Cell)
    .use(CellGroup)
    .use(Dialog)
    .use(Form)
    .use(Divider)
    .use(Area)
    .use(RadioGroup)
    .use(Radio)
    .use(Icon)
    .use(Toast)
    .use(Popup)
    .use(Picker)
    .use(Sidebar)
    .use(SidebarItem)
    .use(Tag)
    .use(Stepper)
    .use(Field)
    .use(Switch)
    .use(Button)
    .use(List);
export default {
  name: "QcxjClubIndex",
  components: {
    PicUploader,
    LoginDialog,
    NavFloatAdd,
    Activity1,
    Activity2,
    Activity3,
    Activity4,
    Activity5,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
  },
  data: function () {
    return {
      validator,
      kaojiShow: false,
      isLoading: false,
      showKefu: false,
      showZhibo: false,
      loading: false,
      finished: false,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      sendShow: false,
      areaList: {},
      message: "",
      areaValue: "",
      submitType: "",
      item: {},
      notice:'',
      cateList: [],
      certRow: {
        danwei: {},
        exame_center: {},
        club: {},
        club_list:[],
        center_list:[]
      },
      aparams: {
        id: 231,
        type: 0, // -1文件 0动态 1是图片  2是视频
        pageNo: 1,
      },
      formData: {},
      row: {
        id: 0,
        pic: [],
        pics: [],
        list: [],
        hotel: {},
        take_list: {},
        bus_list: {},
        saiqu: {
          erweiimg_pic_url: "",
          zhibo_pic_url: "",
        },
      },
      list:[],

      active: 0,
      activeTab: [
        // { name: "文件", num: 0, type: -1 },
        {name: "最新通知", num: 0, type: 0},
        {name: "为您推荐", num: 0, type: 1},
        {name: "动态发布", num: 0, type: 2}
      ],
      params: {
        id: 231,
        type: 0, // -1文件 0动态 1是图片  2是视频
        pageNo: 1,
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "七彩星级、俱乐部、大课间";
    that.getCertOwn();
    that.getCateList();
    this.getList()
    this.getNotice()
    that.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },
    getCateList() {
      let that = this;
      that.$api.get(
          "/api/cms/cateList",
          {
            parent_id: 97,
          },
          (res) => {
            that.cateList = res.data;
          },
          (res) => {
            Toast(res.msg);
          }
      );
    },
    getNotice() {
      let that = this;
      that.$api.get(
          "/api/cms/detail",
          {
            id: 873,
          },
          (res) => {
            that.notice = res.data.data.content;
          },
          (res) => {
            Toast(res.msg);
          }
      );
    },
    getCertOwn() {
      let that = this;
      that.$api.post(
          "/api/user/certindexOwn",
          {},
          (res) => {
            that.certRow = res.data;
          },
          (res) => {
            console.log("errrrrr");
            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {},
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true;
            } else {
              Toast(res.msg);
            }
          }
      );
    },
    toClub() {
      rbLink({
        name: "ExameApplyFormBasic",
        query: {id: this.certRow.id},
      });
    },

    toKaoji() {
      this.kaojiShow = true;
    },

    // 创建考级中心/点
    toKaojiNext() {
      rbLink({
        name: "QcxjStationApplyMine",
      });
    },

    fetch() {
      let that = this;
      that.$api.get(
          "/api/activity/activity",
          that.params,
          (res) => {
            that.loading = false;

            if (res.data.list.currentpage == 1) {
              that.isLoading = false;
              that.row = res.data;
            } else {
              that.row.list.list = that.row.list.list.concat(res.data.list.list);
            }

            if (res.data.list.list.length == 0) {
              that.finished = true;
            }
            that.params.pageNo += 1;
          },
          (res) => {
            // Toast(res.msg);

            console.log("没有登录");
            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {},
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true;
            } else {
              Toast(res.msg);
            }
          }
      );
    },

    onClick(name, title) {
      console.log(name);
      // this.params.type = this.activeTab[name].type;
      // this.params.pageNo = 1;
      // this.fetch();
    },
    toActivityDetail(item) {
      let that = this;
      that.$router.push({
        path: "/activity-activity-detail",
        query: {
          id: item.id,
        },
      });
    },

    getList() {
      let that = this;
      that.$api.get('/api/club/clubList', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
      })
    },


    onSendBox(event, item, i) {
      // console.log(event)
      this.sendShow = event.sendShow;
      this.to_comment_id = event.comment_.id;
      this.placeholder = event.comment_.user_name
          ? "@" + event.comment_.user_name
          : "说点什么...";
      (this.item = item), (this.list_index = i);
    },

    onCommentSend() {
      let that = this;
      console.log("发送评论", this.item, this.message);
      that.$api.get(
          "/api/activity/commentAdd",
          {
            topic_id: this.item.id,
            content: this.message,
            to_comment_id: this.to_comment_id
          },
          res => {
            console.log(res);
            this.row.list.list[this.list_index].comment_list.push(res.data);
            this.message = "";
          },
          res => {

            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {}
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true
            } else {
              Toast(res.msg);
            }
          }
      );
    },
    toUpdate(){
      rbLink({
        name:'ClubHighApplyNew',
        query:{
          id:this.certRow.club.id
        }
      })
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.fetch();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.getCertOwn();
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ClubIndex2.vue?0350b2b5